import api from '../../../services/api';

const BASE_URL = '/products';

const productService = {
  async getProducts(params = {}) {
    const response = await api.get(BASE_URL, { params });
    return response.data.data;
  },

  async getProductById(productId) {
    const response = await api.get(`${BASE_URL}/${productId}`);
    return response.data.data.product;
  },

  async createProduct(productData) {
    const response = await api.post(BASE_URL, productData);
    return response.data.data.product;
  },

  async updateProduct(productId, productData) {
    const response = await api.patch(
      `${BASE_URL}/${productId}`,
      productData
    );

    return response.data.data.product;
  },

  async updateProductStatus(productId, isActive) {
    const response = await api.patch(
      `${BASE_URL}/${productId}/status`,
      { is_active: isActive }
    );

    return response.data.data.product;
  },
};

export default productService;